const getInitialState = () => ({
  user: null,
  userAuth: null,
  userRoles: null,
  impersonatedUserId: null,
  userOrganization: {
    id: '',
    name: ''
  },
  selectedOrganization: {
    id: '',
    name: '',
    hubspotId: ''
  },
  userPermissions: {},
  organizationUsers: [],
  users: [],
  devices: [],
  crops: [],
  fields: [],
  organizationDevices: [],
  availableCampaigns: []
})

export default {
  state: {
    ...getInitialState(),
    timeRange: {
      from: new Date().setDate(new Date().getDate() - 7),
      to: new Date().getTime(),
      type: 1
    }
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setUserAuth (state, user) {
      state.userAuth = user
    },
    setTimeRange (state, payload) {
      state.timeRange.from = payload.from
      state.timeRange.to = payload.to
      state.timeRange.type = payload.type
    },
    setUserRoles (state, payload) {
      state.userRoles = payload
    },
    setOrganization (state, payload) {
      state.userOrganization = {...state.userOrganization, ...payload}
      state.selectedOrganization = {...state.selectedOrganization, ...payload}
    },
    setSelectedOrganization (state, payload) {
      state.selectedOrganization = {...state.selectedOrganization, ...payload}
    },
    resetState (state) {
      const s = getInitialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setUserPermissions (state, payload) {
      state.userPermissions = payload
    },
    setOrganizationUsers (state, payload) {
      state.organizationUsers = payload
    },
    setOrganizationFields (state, payload) {
      state.organizationFields = payload
    },
    setUsers (state, payload) {
      state.users = payload
    },
    setDevices (state, payload) {
      state.devices = payload
    },
    setCrops (state, payload) {
      state.crops = payload
    },
    setFields (state, payload) {
      state.fields = payload
    },
    setImpersonatedUserId (state, payload) {
      state.impersonatedUserId = payload
    },
    setOrganizationDevices (state, payload) {
      state.organizationDevices = payload
    },
    updateCampaignUsers (state, payload) {
      const campaignIndex = state.user.campaigns.findIndex(campaign => campaign.id === payload.campaignId)
      if (campaignIndex !== -1) {
        // Add processed users to the existing users array
        if (!state.user.campaigns[campaignIndex].users) {
          state.user.campaigns[campaignIndex].users = []
        }
        state.user.campaigns[campaignIndex].users.push(...payload.processedUsers)
      }
    },
    updateCampaign (state, payload) {
      const campaignIndex = state.user.campaigns.findIndex(campaign => campaign.id === payload.campaignId)
      if (campaignIndex !== -1) {
        state.user.campaigns[campaignIndex] = payload.campaignData
      }
    },
    setAvailableCampaigns (state, payload) {
      state.availableCampaigns = payload
    }
  },
  actions: {
    signUserIn ({commit}, payload) {
      commit('setUser', payload)
    },
    autoSignIn (context, payload) {
      context.commit('setUserAuth', payload)
    },
    resetPasswordWithEmail ({ commit }) {
      // const { email } = payload
      commit('setLoading', true)
      // Petition a graphql, concatenada con el siguiente then..
      // .then(
      //   () => {
      //     commit('setLoading', false)
      //     console.log('Email Sent')
      //   }
      // )
      // .catch(
      //   error => {
      //     commit('setLoading', false)
      //     commit('setError', error)
      //     console.log(error)
      //   }
      // )
    },
    logout ({commit}) {
      commit('resetState')
    },
    setTimeRange ({commit}, payload) {
      commit('setTimeRange', payload)
    },
    setUserRoles ({commit}, payload) {
      commit('setUserRoles', payload)
    },
    setOrganization ({commit}, payload) {
      commit('setOrganization', payload)
    },
    setSelectedOrganization ({commit}, payload) {
      commit('setSelectedOrganization', payload)
    },
    setUserPermissions ({commit}, payload) {
      commit('setUserPermissions', payload)
    },
    updateCampaignUsers ({commit}, payload) {
      commit('updateCampaignUsers', payload)
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    userAuth (state) {
      return state.userAuth
    },
    timeRange (state) {
      return state.timeRange
    },
    userRoles (state) {
      return state.userRoles
    },
    userOrganization (state) {
      return state.userOrganization
    },
    selectedOrganization (state) {
      return state.selectedOrganization
    },
    userPermissions (state) {
      return state.userPermissions
    },
    organizationUsers (state) {
      return state.organizationUsers
    },
    organizationFields (state) {
      return state.organizationFields
    },
    users (state) {
      return state.users
    },
    devices (state) {
      return state.devices
    },
    crops (state) {
      return state.crops
    },
    fields (state) {
      return state.fields
    },
    impersonatedUserId (state) {
      return state.impersonatedUserId
    },
    getCampaign: (state) => (id) => {
      return state.user.campaigns.find(campaign => campaign.id === id)
    },
    getCampaignFields: (state) => (campaignId) => {
      if (!state.user || !state.user.campaigns) {
        return []
      }
      const campaign = state.user.campaigns.find(campaign => campaign.id === campaignId)
      if (!campaign || !campaign.fields) {
        return []
      }
      return campaign.fields
    },
    organizationDevices (state) {
      return state.organizationDevices
    },
    availableCampaigns (state) {
      return state.availableCampaigns
    },
    getUserById: (state) => (userId) => {
      return state.users.find(user => user.id === userId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js